import { request } from '../../api/client';

const installedKey = 'skrepka-finder-connected:1';
let connected = false;
export function finderConnected() {
  try { return connected || localStorage.getItem(installedKey) === 'yes'; } catch { return connected; }
}
export function beginFinderClick(activate = (uri: string) => { window.location.href = uri; }) {
  const nonce = Array.from(crypto.getRandomValues(new Uint8Array(32)), byte => byte.toString(16).padStart(2, '0')).join('');
  // Must happen inside the click, before any network await (Safari activation).
  activate(`skrepka-folders://finder/${nonce}`);
  return nonce;
}
export async function finderCommand(nonce: string, signal?: AbortSignal, ticket?: string): Promise<boolean> {
  if (!/^[a-f0-9]{64}$/.test(nonce) || signal?.aborted) return false;
  const controller = new AbortController();
  const abort = () => controller.abort();
  signal?.addEventListener('abort', abort, { once: true });
  const timer = setTimeout(abort, 45000);
  let created = false, finished = false;
  try {
    created = true;
    await request('/api/explorer/finder-command', { method: 'POST', body: { nonce, kind: ticket ? 'open' : 'probe', ...(ticket ? { ticket } : {}) }, signal: controller.signal });
    while (!controller.signal.aborted) {
      const state = await request<{ phase: string; protocol: number }>('/api/explorer/finder-status', { method: 'POST', body: { nonce }, signal: controller.signal });
      if (state.phase === 'opened' || state.phase === 'failed' || state.phase === 'cancelled') {
        finished = true;
        if (state.phase !== 'opened' || state.protocol !== 1) return false;
        connected = true;
        try { localStorage.setItem(installedKey, 'yes'); } catch { /* Private browsing. */ }
        return true;
      }
      await new Promise<void>(resolve => {
        const done = () => { clearTimeout(delay); controller.signal.removeEventListener('abort', done); resolve(); };
        const delay = setTimeout(done, 600);
        controller.signal.addEventListener('abort', done, { once: true });
      });
    }
  } catch { /* Unavailable helper, revoked rights or network interruption. */ }
  finally {
    clearTimeout(timer); signal?.removeEventListener('abort', abort);
    if (created && !finished) void request('/api/explorer/finder-cancel', { method: 'POST', body: { nonce }, keepalive: true }).catch(() => {});
  }
  return false;
}
